module.exports = __webpack_public_path__ + "static/img/app.00d26ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/app.png
// module id = 1157
// module chunks = 18